import { Component, computed, input, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { SvgIconComponent } from "../../components/svg-icon/svg-icon.component";

import { ProgressSpinnerModule } from "@openng/optimus-ui/progressspinner";
import { createTimeoutSignal } from "../../utils/timeout.utils";
import { TimeoutComponent } from "../../components/timeout/timeout.component";
import { OpenNoticeConfig } from "../../../models/ui/openNoticeConfig";

@Component({
  standalone: true,
  selector: "app-open-notice-card",
  imports: [TranslateModule, SvgIconComponent, ProgressSpinnerModule, TimeoutComponent],
  templateUrl: "./open-notice-card.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./open-notice-card.component.scss",
})
export class OpenNoticeCardComponent {
  public config = input<OpenNoticeConfig>();
  public values = input<number[] | null>();
  public loading = computed(() => this.values() === null);
  public timeOut = createTimeoutSignal(this.loading);
}
